// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"coinbaseWallet_wrapper__343RR"};